import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({ baseURL: `${BASE}/api/public` });

export function getTenantInfo(slug)                    { return api.get(`/${slug}/info`).then(r => r.data.data); }
export function getServices(slug)                      { return api.get(`/${slug}/services`).then(r => r.data.data); }
export function getStaff(slug, serviceId)              { return api.get(`/${slug}/staff?serviceId=${serviceId}`).then(r => r.data.data); }
export function getAvailability(slug, { serviceId, staffId, date }) {
  const q = new URLSearchParams({ serviceId, date, ...(staffId ? { staffId } : {}) });
  return api.get(`/${slug}/availability?${q}`).then(r => r.data.data);
}
export function createBooking(slug, payload)           { return api.post(`/${slug}/bookings`, payload).then(r => r.data.data); }
